import { Button, Input, message, Switch } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import axios from '../../util/Api';
import { Form, useFormik } from 'formik';
import React, { useState } from 'react';
import Item from '../../components/Form/Item';
import { useHistory } from 'react-router-dom';

const Edit = ({ sickness }) => {
  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      name: sickness.name,
      active: sickness.status.is_active
    },
    onSubmit: (values, actions) => {
      const url = `/sickness/update?id=${sickness.id}`;
      const data = { ...values };
      axios.post(url, data).then(resp => {
        if (resp.data.success) {
          message.success("Riwayat kesehatan berhasil diperbarui");
          setIsModalVisible(false);
          actions.setSubmitting(false);
          history.push(`/sickness`);
        } else {
          message.error("Gagal memperbarui riwayat kesehatan");
        }
      }).catch(err => {
        message.error("Gagal memperbarui riwayat kesehatan");
      });
    }
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  
  const handleOk = () => {
    formik.submitForm();
  }
  const handleCancel = () => {
    setIsModalVisible(false);
  }

  return (
    <div className="gx-text-right">
      <Button type="default" size="small" onClick={() => setIsModalVisible(true)}>Edit</Button>
      <Modal
        closable={false}
        title="Edit Riwayat Kesehatan"
        visible={isModalVisible}
        onOk={handleOk}
        okText="Simpan Perubahan"
        onCancel={handleCancel}
        cancelText="Batal"
        confirmLoading={formik.isSubmitting}
      >
        <form onSubmit={formik.handleSubmit}>
          <Item name="Deskripsi">
            <Input autoFocus name="name" value={formik.values.name} onChange={formik.handleChange} />
          </Item>
          <Item name="Status">
            <Switch
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              defaultChecked={formik.values.active}
              onChange={(e) => formik.setFieldValue("active", e)}
            />
          </Item>
        </form>
      </Modal>
    </div>
  );
}

export default Edit;